import React, { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { IBindingAction } from '../../../../common/models/callback';
import Icon from '../../../../components/Icon';
import Illustration from '../../../../components/Illustration';
import LinkButton from '../../../../components/LinkButton';

interface IProps {
  onButtonClick?: IBindingAction;
  variant: 'questionBank' | 'table';
}

const NoDataPlaceholder: FunctionComponent<IProps> = ({ onButtonClick, variant }) => (
  variant === 'table' ? (
    <Illustration
      variant="ipad"
      height="16rem"
      header={(
        <FormattedMessage
          id="surveyBuilder.noResults"
          defaultMessage="Hmm... this doesn’t look right"
        />
      )}
      description={(
        <FormattedMessage
          id="surveyBuilder.noResultsHint"
          defaultMessage="Are you sure you don’t want any free response questions?"
        />
      )}
      button={(
        <LinkButton
          textIntlId="surveyBuilder.noResultsButton"
          defaultMessage="Add from question bank"
          onClick={onButtonClick}
          icon={<Icon icon="plus" />}
          iconPosition="right"
        />
      )}
    />
  ) : (
    <Illustration
      variant="binoculars"
      height="22rem"
      header={<FormattedMessage id="resultsNotFound" defaultMessage="Hmm... no matches found" />}
      description={(
        <FormattedMessage
          id="resultsNotFoundHint"
          defaultMessage="Try searching for something else"
        />
      )}
    />
  )
);

export default NoDataPlaceholder;
